"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface Copy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, Copy> = {
  en: {
    eyebrow: "Sintered Porous Media",
    heading: "Request Sintered Mesh Specifications or a Formal Quote",
    lead: "Send your target micron rating, layer structure, mechanical dimensions, or drawings. Our filtration engineers will review your operating parameters and provide a comprehensive proposal.",
    secondaryLabel: "Technical Resources"
  },
  zh: {
    eyebrow: "烧结多孔滤材",
    heading: "索取烧结网规格参数或正式报价方案",
    lead: "请发送您的目标过滤精度、层叠结构配置、机械尺寸或工程图纸。我们的过滤技术工程师将审核工况参数并提供完整报价方案。",
    secondaryLabel: "技术资源"
  },
  es: {
    eyebrow: "Medios porosos sinterizados",
    heading: "Solicite especificaciones de malla sinterizada o presupuesto formal",
    lead: "Envíenos su micraje objetivo, estructura de capas, dimensiones mecánicas o planos. Nuestros ingenieros revisarán sus parámetros de trabajo y presentarán una propuesta completa.",
    secondaryLabel: "Recursos técnicos"
  },
  de: {
    eyebrow: "Sintermetallgewebe",
    heading: "Spezifikationen für Sintergewebe oder formelles Angebot anfragen",
    lead: "Senden Sie uns die gewünschte Filterfeinheit, den Schichtaufbau, Maße oder technische Zeichnungen. Unsere Ingenieure prüfen Ihre Prozessparameter und unterbreiten ein fundiertes Angebot.",
    secondaryLabel: "Technische Ressourcen"
  },
  fr: {
    eyebrow: "Milieux poreux frittés",
    heading: "Demandez des spécifications pour toile frittée ou un devis formel",
    lead: "Indiquez votre seuil de filtration cible, la structure multicouche, les cotes mécaniques ou vos plans. Nos ingénieurs évalueront vos conditions d'exploitation et vous répondront rapidement.",
    secondaryLabel: "Ressources techniques"
  },
  pt: {
    eyebrow: "Meios porosos sinterizados",
    heading: "Solicite especificações de malha sinterizada ou orçamento formal",
    lead: "Envie a retenção em mícrons desejada, a estrutura de camadas, dimensões mecânicas ou desenhos técnicos. Nossos engenheiros de filtração avaliarão seus parâmetros com agilidade.",
    secondaryLabel: "Recursos técnicos"
  }
};
export default function QuoteCTA() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  const quoteLabel = pick(lang, COMMON.requestQuote);
  return <CtaBand id="quotecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: quoteLabel,
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/TechnicalResourcesPage"
  }} />;
}